import { render, staticRenderFns } from "./SubdomainSettingsCert.vue?vue&type=template&id=ec7151e0&scoped=true&"
import script from "./SubdomainSettingsCert.vue?vue&type=script&lang=js&"
export * from "./SubdomainSettingsCert.vue?vue&type=script&lang=js&"
import style0 from "./SubdomainSettingsCert.vue?vue&type=style&index=0&id=ec7151e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7151e0",
  null
  
)

export default component.exports